module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/lqeHX9/tc-custom/9781488046308.jpg?1704761694385",
      "alt": "This image is the cover for the book Forbidden Texan, Texas Promises"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Forbidden Texan, Texas Promises\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A family feud made them enemies—")]), _c('br'), _c('br'), _c('b', [_c('i', [_vm._v("A promise made them lovers.")])]), _c('br'), _c('br'), _vm._v("Wealthy Texan Jake Ralston made a promise to his best friend: to end the century-old feud between the Ralstons and Kincaids. Hiring Emily Kincaid is the first step…if he can deny their intense attraction. But once they’re at his ranch, they can’t say no—until a shocking family secret resurfaces. Now Jake could lose everything, including this irresistible woman.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sara Orwig\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Sara Orwig lives in Oklahoma and has a deep love of Texas. With a master’s degree in English, Sara taught high school English, was Writer-in-Residence at the University of Central Oklahoma and was one of the first inductees into the Oklahoma Professional Writers Hall of Fame. Sara has written mainstream fiction, historical and contemporary romance. Books are beloved treasures that take Sara to magical worlds. She loves both reading and writing them.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0